export const TRACK_FREQUENCY_UPDATE = 200 // The time frequency witch track will be syncronized with state
export const TRACK_REQUEST_FREQUENCY = 5000 // The time frequency witch will send requests to backend with audio consum
export const PREVIEW_LIMIT_PERCENT = 8
